export var environment = {
    configBaseUrl: 'https://chat.rogers.com'
};